import { API } from "@/lib/api";

const cleanName = (s) =>
  (s || "download")
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, "_")
    .replace(/^_|_$/g, "")
    .slice(0, 40) || "download";

const buildProxyUrl = (url, filename) => {
  const params = new URLSearchParams({ url, filename });
  return `${API}/proxy?${params.toString()}`;
};

export const triggerDownload = (url, filename) => {
  const proxy = buildProxyUrl(url, filename);
  const a = document.createElement("a");
  a.href = proxy;
  a.rel = "noopener noreferrer";
  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);
};

export { cleanName };
